import _ from 'lodash';
import $ from 'jquery';
import Promise from 'bluebird';

import i18n from '../config/i18n';

function getErrorMessage(jqXHR) {
  let errMsg = '';

  try {
    if (jqXHR.readyState === 0) {
      errMsg = i18n.t('noRespMsg');
    } else if (jqXHR.responseText) {
      errMsg += `${jqXHR.status} ${jqXHR.statusText}`;
      errMsg += `: ${JSON.parse(jqXHR.responseText).error.message}`;
    }
  } catch (err) {
    // ajax can not handle binary response (PDF) properly.
    // Error will occur even if the response status is 200.
    // Can not parse the responseText since it is binary type.
    errMsg = 'Fail to parse the response text.';
  }
  return errMsg;
}

export default function ajax(method, url, additionalOptions) {
  if (!method || !url) {
    throw new Error(i18n.t('ajaxParamsErrMsg'));
  }

  return new Promise((resolve, reject) => {
    let ajaxOptions = {
      url,
      method,
      contentType: 'application/json',
      dataType: 'json',
      success: (data) => {
        resolve(data);
      },
      error: (jqXHR) => {
        const error = new Error(getErrorMessage(jqXHR));
        error.statusCode = jqXHR.status;
        reject(error);
      },
    };

    if (!_.isEmpty(additionalOptions) && additionalOptions.urlParams) {
      // append url with params from additional.urlParams. For example: "?access_token=..."
      ajaxOptions.url = `${ajaxOptions.url}?${$.param(additionalOptions.urlParams)}`;
    }

    // merge and overwrite default options if provided in additional Options
    ajaxOptions = _.merge(ajaxOptions, additionalOptions);

    $.ajax(ajaxOptions);
  });
}



// WEBPACK FOOTER //
// ./src/utils/ajax.js